module.exports = __webpack_public_path__ + "img/no-data.2d0b16d5.svg";